/* eslint-disable prettier/prettier */
import "./smartProperties.css";
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import elementHelper from "bpmn-js-properties-panel/lib/helper/ElementHelper";
import { escapeHTML } from "bpmn-js-properties-panel/lib/Utils";
import { forEach } from "lodash";
import { domify } from "min-dom";

import smartDocumentsForSignatureButton from "./smartDocumentsForSignatureButton";
import { getUnitPropertie } from "../../../../../containers/smart/camunda/forms/functions";
import { themeOptions as theme } from "../../../../../theme/materialTheme";

function ensureFormKeyAndDataSupported(element) {
  return is(element, "bpmn:UserTask");
}

export default function (group, element, bpmnFactory, translate, modeling) {
  const id = "documents-for-signature";
  const label = translate("Documents for signature");

  const businessObject = getBusinessObject(element);

  const modelProperty = "name";
  const defaultSize = 5;

  const createOption = function (value) {
    return (
      '<option value="' +
      escapeHTML(value) +
      '" data-value data-name="extensionElementValue">' +
      escapeHTML(value) +
      "</option>"
    );
  };

  const saveDocuments = function (
    businessObject,
    element,
    extensionElements,
    bpmnFactory,
    selectBox,
    documentsForSignature = [],
  ) {
    const bo = businessObject;

    let camundaProperties = null;
    let findAssinatureConfig = false;

    const docValues = documentsForSignature.map((d) => {
      return {
        id: d.id,
        type: "Documento",
        name: d.name || null,
        isSignatureRequired: d.isSignatureRequired,
      };
    });

    const docConfig = {
      id: "assinaturaConfig",
      properties: [
        {
          id: "documentsToSign",
          value: docValues,
        },
      ],
    };

    // limpando o componente atual (TODO verificar se é realmente necessário)
    if (documentsForSignature.length > 0) {
      while (selectBox.options.length > 0) {
        selectBox.options.remove(0);
      }
    }

    // se a lista estiver vazia, então remove o item caso exista
    if (docValues.length <= 0) {
      if (extensionElements) {
        camundaProperties = extensionElements.values.find(function (elem) {
          if (elem.$type === "camunda:Properties") {
            return true;
          }
          return false;
        });

        if (camundaProperties && camundaProperties.values) {
          // remove
          const assinaturaConfigIndex = camundaProperties.values.findIndex(
            function (elem) {
              if (elem.name === "assinaturaConfig") {
                return true;
              }
              return false;
            },
          );

          if (assinaturaConfigIndex !== -1) {
            camundaProperties.values.splice(assinaturaConfigIndex, 1);
          }

          const camundaPropertiesIndex = extensionElements.values.findIndex(
            function (elem) {
              if (elem.$type === "camunda:Properties") {
                return true;
              }
              return false;
            },
          );

          if (camundaPropertiesIndex !== -1) {
            extensionElements.values[camundaPropertiesIndex] =
              camundaProperties;
          } else {
            extensionElements.values.push(camundaProperties);
          }

          bo.set("extensionElements", extensionElements);

          modeling.updateProperties(element, {});
        }
      }
    } else {
      // cria extensionElements caso não exista
      if (!extensionElements) {
        extensionElements = elementHelper.createElement(
          "bpmn:ExtensionElements",
          { values: [] },
          businessObject,
          bpmnFactory,
        );
        camundaProperties = elementHelper.createElement(
          "camunda:Properties",
          { values: [] },
          extensionElements,
          bpmnFactory,
        );
      } else {
        camundaProperties = extensionElements.values.find(function (elem) {
          if (elem.$type === "camunda:Properties") {
            return true;
          }
          return false;
        });

        if (!camundaProperties) {
          camundaProperties = elementHelper.createElement(
            "camunda:Properties",
            { values: [] },
            extensionElements,
            bpmnFactory,
          );
        }

        if (camundaProperties.values === undefined) {
          camundaProperties.set("values", []);
        }
      }

      // atualizando a propriedade "assinaturaConfig"
      for (
        let idxProperty = 0;
        idxProperty < camundaProperties.values.length;
        idxProperty++
      ) {
        const camundaProperty = camundaProperties.values[idxProperty];
        if (camundaProperty.name === "assinaturaConfig") {
          findAssinatureConfig = true;
          camundaProperties.values[idxProperty] = elementHelper.createElement(
            "camunda:Property",
            { name: "assinaturaConfig", value: JSON.stringify(docConfig) },
            camundaProperties,
            bpmnFactory,
          );
        }
      }

      if (!findAssinatureConfig) {
        camundaProperties.values.push(
          elementHelper.createElement(
            "camunda:Property",
            { name: "assinaturaConfig", value: JSON.stringify(docConfig) },
            camundaProperties,
            bpmnFactory,
          ),
        );
      }

      // atualizando visualização no modeler (TODO verificar se é realmente necessário)
      for (let i = 0; i < docValues.length; i++) {
        const template = domify(createOption(docValues[i].id));
        selectBox.appendChild(template);
      }

      // atualizando camunda:Properties
      const camundaPropertiesIndex = extensionElements.values.findIndex(
        function (elem) {
          if (elem.$type === "camunda:Properties") {
            return true;
          }
          return false;
        },
      );

      if (camundaPropertiesIndex !== -1) {
        extensionElements.values[camundaPropertiesIndex] = camundaProperties;
      } else {
        extensionElements.values.push(camundaProperties);
      }

      bo.set("extensionElements", extensionElements);

      modeling.updateProperties(element, {});
    }
  };

  if (!ensureFormKeyAndDataSupported(element)) {
    return;
  }

  // Lista os campos
  group.entries.push({
    id,
    label,
    modelProperty,
    html:
      "<style>" +
      ".btn { border: 2px solid black; background-color: white; color: black; padding: 14px 28px; font-size: 16px; cursor: pointer; } " +
      ".err {border-color: #900020;color: #900020;}" +
      ".err:hover {background: #900020;color: white;}" +
      ".info {border-color: #000A69;color: dodgerblue;}" +
      `.info:hover {background: ${theme.palette.primary.main};color: white;}</style>` +
      '<div class="bpp-row bpp-element-list" ' +
      ">" +
      '<label for="cam-extensionElements-' +
      escapeHTML(id) +
      '">' +
      escapeHTML(label) +
      "</label>" +
      '<div class="bpp-field-wrapper">' +
      '<select id="cam-extensionElements-' +
      escapeHTML(id) +
      '"' +
      'name="selectedExtensionElement" ' +
      'size="' +
      escapeHTML(defaultSize) +
      '" ' +
      "data-list-entry-container " +
      'data-on-change="selectElement">' +
      "</select>",
    get: (element, node) => {
      const bo = businessObject || getBusinessObject(element);

      const extensionElements = bo.get("extensionElements");

      let docsToSign = [];

      if (extensionElements) {
        const extensionProperties = extensionElements.values.find(
          function (elem) {
            if (elem.$type === "camunda:Properties") {
              return true;
            }
            return false;
          },
        );

        if (extensionProperties && extensionProperties.values) {
          for (
            let idxProperty = 0;
            idxProperty < extensionProperties.values.length;
            idxProperty++
          ) {
            const camundaProperty = extensionProperties.values[idxProperty];
            if (camundaProperty.name === "assinaturaConfig") {
              let docConfig = {};
              try {
                docConfig = JSON.parse(camundaProperty.value);
              } catch (err) {
                console.error(err);
              }

              docsToSign = getUnitPropertie(docConfig, "documentsToSign") || [];
            }
          }
        }
      }

      const result = [];
      forEach(docsToSign, function (elem) {
        result.push({
          extensionElementValue: elem.id,
        });
      });

      return result;
    },
    createListEntryTemplate(value, index, selectBox) {
      return createOption(value.extensionElementValue);
    },
  });

  //Botão de listar documentos para assinatura
  const documentsForSignatureButton = smartDocumentsForSignatureButton(
    element,
    bpmnFactory,
    {
      id: "documents-for-signature-button",
      boxId: id,
    },
    translate,
    modeling,
    saveDocuments,
  );
  group.entries.push(documentsForSignatureButton);
}
